import { signInWithPhoneNumber } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { setOtpData } from "store/actions/Authentication/otp";
import { checkUserExistsApi } from "store/services/Authentication";
import { showToast } from "utils/showToast";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { firebaseRecaptchaVerifier } from "utils";
import { auth } from "../../firebase";
import ConfirmationModal from "components/ConfirmationModal";
import { signupAlHalal, signupMav } from "assets/svgs";
import { MAVENCERY_STORES_NAMES } from "constants";
import CustomPhoneInput from "components/CustomPhoneInput";

const Signup = ({ isSwapped, setIsSwapped }) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [appVerifier, setAppVerifier] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({
    title: "User Already Exists",
    body: "User already exists. Kindly login again.",
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const handleConfirmationModalToggle = (id) => {
    setIsConfirmationModalOpen(!isConfirmationModalOpen);
  };

  const gotoLogin = () => {
    if (type === "signup") {
      setIsSwapped(!isSwapped);
      setSearchParams({ type: "login" });
      navigate("/auth?type=login");
    }
  };

  useEffect(() => {
    const { appVerifier, error } = firebaseRecaptchaVerifier();
    setAppVerifier(appVerifier);
    if (error) {
      showToast(error, "error", true);
    }
  }, []);

  const handlePhoneChange = (value) => {
    setPhone(value);
    setPhoneError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    // First name and last name are optional
    // Email is optional but must be valid if provided
    if (formData.email && formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
      return false;
    }
    if (!phone || !isValidPhoneNumber(phone)) {
      setPhoneError("Please enter a valid phone number");
      return false;
    }
    return true;
  };

  const getOtp = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const checkUserExists = await checkUserExistsApi(
        user?.accessToken,
        phone,
        selectedStore?.isWhiteLabel,
        selectedStore?.id,
        formData?.email
      );
      if (!checkUserExists.success) {
        setModalData({ ...modalData, body: checkUserExists?.message.message });
        setIsConfirmationModalOpen(true);
      } else {
        setLoading(true);

        const confirmationResult = await signInWithPhoneNumber(
          auth,
          phone,
          appVerifier
        );
        if (confirmationResult) {
          dispatch(
            setOtpData({
              result: confirmationResult,
              formData: formData,
              phone: phone,
            })
          );
          navigate("/auth/verify?type=signup");
          showToast("OTP sent successfully", "success", true);
          setLoading(false);
        }
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      showToast(err.message, "error", true);
    }
  };
  return (
    <div className="lg:w-[85%] md:w-full w-full p-8 sm:shadow-none lg:shadow-none  md:shadow-gray-shadow   ">
      <div className="mx-auto w-44 h-44">
        <img
          src={
            !selectedStore?.isWhiteLabel
              ? signupMav
              : selectedStore?.isWhiteLabel &&
                selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
              ? signupAlHalal
              : signupMav
          }
          alt="signup"
        />
      </div>
      <p
        className={`text-center font-bold my-2 ${
          !selectedStore?.isWhiteLabel
            ? "text-theme-color"
            : selectedStore?.isWhiteLabel &&
              selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
            ? "text-orangeColor"
            : "text-gray-900"
        }`}
      >
        Sign Up to{" "}
        {!selectedStore?.isWhiteLabel
          ? "Mavencery"
          : selectedStore?.isWhiteLabel &&
            selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
          ? selectedStore.name
          : "Nisa Local"}
      </p>
      <form onSubmit={getOtp} className="space-y-3 ">
        
        <div className="flex flex-col gap-3 lg:flex-row lg:justify-between lg:gap-1">
          <div className="lg:w-1/2">
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First Name"
              className="w-full p-2 text-sm border border-gray-400 rounded-md focus:border-theme-color focus:outline-none"
            />
          </div>
          <div className="lg:w-1/2">
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              className="w-full p-2 text-sm border border-gray-400 rounded-md focus:border-theme-color focus:outline-none"
            />
          </div>
        </div>
        
        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="w-full p-2 text-sm border border-gray-400 rounded-md focus:border-theme-color focus:outline-none"
          />
        </div>
        <div className="w-full mt-4 bg-white border border-gray-400 rounded-md">
          <CustomPhoneInput
            phone={phone}
            handlePhoneChange={handlePhoneChange}
          />
        </div>
        {phoneError && (
          <div>
            <p className="mt-1 text-xs text-red-300">{phoneError}</p>
          </div>
        )}
        <div>
          <button
            disabled={loading}
            style={{
              backgroundColor: loading
                ? "lightGray"
                : selectedStore?.theme.backgroundColor,
            }}
            type="submit"
            className="w-full px-4 py-2 mt-2 mb-2 text-sm text-white transition duration-300 rounded-md hover:bg-lighterPurple"
          >
            Request OTP
          </button>
        </div>
        <div
          className="w-full lg:hidden md:inline-block sm:inline-block"
          onClick={gotoLogin}
        >
          <button className="w-full px-4 py-2 mb-2 text-sm text-white transition duration-300 bg-red-500 rounded-md ">
            Already have an account?
          </button>
        </div>
      </form>
      <div id="recaptcha-container"></div>
      {isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          onClose={handleConfirmationModalToggle}
          modalData={modalData}
          handleSubmit={gotoLogin}
        />
      )}
    </div>
  );
};

export default Signup;
